import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';

// 按需导入Element UI组件
import {
  Button,
  Dialog,
  Radio,
  RadioGroup,
  Upload,
  Select,
  Option,
  Form,
  FormItem,
  Row,
  Col,
  Input,
  DatePicker,
  Tooltip,
  Checkbox,
  Image,
  Popover,
  MessageBox,
  Notification,
  Message,
  Loading
} from 'element-ui';
export default (Vue) => {
  // 注册组件
  Vue.use(Button);
  Vue.use(Dialog);
  Vue.use(Radio);
  Vue.use(RadioGroup);
  Vue.use(Upload);
  Vue.use(Select);
  Vue.use(Option);
  Vue.use(Form);
  Vue.use(FormItem);
  Vue.use(Row);
  Vue.use(Col);
  Vue.use(Input);
  Vue.use(DatePicker);
  Vue.use(Tooltip);
  Vue.use(Checkbox);
  Vue.use(Image);
  Vue.use(Popover);

  // 挂载 Element UI 全局方法
  Vue.prototype.$msgbox = MessageBox;
  Vue.prototype.$alert = MessageBox.alert;
  Vue.prototype.$confirm = MessageBox.confirm;
  Vue.prototype.$prompt = MessageBox.prompt;
  Vue.prototype.$notify = Notification;
  Vue.prototype.$message = Message;

  // Loading 服务挂载
  Vue.use(Loading.directive);
  Vue.prototype.$loading = Loading.service;
};
